import type { ChatMessage } from "@/features/chat/shared/types";

export const mockLiveMessage: ChatMessage = {
  id: "mock-live-1",
  sender_id: "654ff48d-23f4-4e2c-8269-b7da00857735",
  receiver_id: "ea1f85af-5096-4643-8254-8fc5c6f34db3",
  date: new Date().toISOString(),
  type: "live",
  content: "Test live message",
  status: "active",
  read_at: null
};

export const mockTipMessage: ChatMessage = {
  id: "mock-tip-1",
  sender_id: "ea1f85af-5096-4643-8254-8fc5c6f34db3",
  receiver_id: "654ff48d-23f4-4e2c-8269-b7da00857735",
  date: new Date().toISOString(),
  type: "tip",
  content: "Un pourboire de 10 EUR a été envoyé avec succès !",
  status: "active",
  read_at: null
};
